export default __webpack_public_path__ + "static/farm-7c8abc28f99cf2398f39a575eefb3121.jpg";